module.exports = __webpack_public_path__ + "img/barrelsandcouple-1-1@1x.d4d0505d.png";